import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ImportFileType } from 'src/app/models/ImportFileType';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { MapService } from 'src/app/services/map.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ProjectService } from 'src/app/services/project.service';
import { RouteSegmentsService } from 'src/app/services/route-segments.service';
import { HttpClient } from '@angular/common/http';
import { RouteTypeList } from 'src/app/models/RouteTypeList';
import { RoutesegmentTypeSelectionComponent } from '../routesegment-type-selection/routesegment-type-selection.component';
import { RouteSegmentsXMLModel } from 'src/app/models/routeSegmentsXMLModel';
import { UiBlockService } from 'src/app/services/ui-block.service';
import { PointsService } from 'src/app/services/points.service';

@Component({
  selector: 'app-route-segments-xml',
  templateUrl: './route-segments-xml.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class RouteSegmentsXmlComponent implements OnInit {

  @Input()
  isEad51: boolean;

  constructor(private bsModalRef : BsModalRef,
    private endpointService: EndpointsService,
    public http: HttpClient,
    private modalService: ModalControlService,
    public routeSegmentsService : RouteSegmentsService,
    private popupService : BsModalService,
    private uiBlock: UiBlockService,
    private pointsService: PointsService
    ) {
    this.routeSegmentsService.modelXML = new RouteSegmentsXMLModel();
  }

  ngOnInit(): void {
  }

  cancelImport():void {
    this.bsModalRef.hide();
  }

  saveFile(event : any) : void {
    this.routeSegmentsService.modelXML.file = event.target.files[0];
    this.routeSegmentsService.modelXML.layerName = event.target.files[0].name.substr(0, event.target.files[0].name.indexOf('.'));
  }

  startImport():void {
    if(this.routeSegmentsService.modelXML.file == null){
      this.modalService.showMesssageModal("Error", "You have to choose a file before import it.");
      return;
    }
    const formData: FormData = new FormData();
    formData.append('file', this.routeSegmentsService.modelXML.file, this.routeSegmentsService.modelXML.file.name);
    let importType :ImportFileType;
    this.isEad51? importType = ImportFileType.ROUTESEGMENTS_EAD51: importType = ImportFileType.ROUTESEGMENTS_EAD45_PHASE1;
    this.uiBlock.startBlock('Parsing XML file...');
    this.http
      .post(
        this.endpointService.endpointParseImportFileRouteSegments + '/' + importType,
        formData,
        this.endpointService.httpOptions
      )
      .subscribe((routeTypeList:RouteTypeList[])=>{
        this.uiBlock.stopBlock();
        if(routeTypeList.length>0){ 
          const bsRef:BsModalRef = this.popupService.show(RoutesegmentTypeSelectionComponent);
          bsRef.content.formData = formData;
          bsRef.content.routeTypeMap = RoutesegmentTypeSelectionComponent.createRouteTypeMap(routeTypeList);
          bsRef.content.routeTypeRowExpanded = RoutesegmentTypeSelectionComponent.createRowActiveProperty(bsRef.content.routeTypeMap);
          bsRef.content.isEad51 = this.isEad51;
        } else {
          this.modalService.showMesssageModal('Route Segments','No Route Segments available to import.');
        }
      }, (error) => {
        this.uiBlock.stopBlock();
        this.pointsService.handleImportError(error, "XML")
      })
  }
}
